import { render, staticRenderFns } from "./index-v3.vue?vue&type=template&id=659a8892&scoped=true&"
import script from "./index-v3.vue?vue&type=script&lang=js&"
export * from "./index-v3.vue?vue&type=script&lang=js&"
import style0 from "./index-v3.vue?vue&type=style&index=0&id=659a8892&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659a8892",
  null
  
)

export default component.exports